<template>
    <div>
        <dashboard-users-invite-modal
            v-if="showInviteModal"
            @close="closeModal"
        />
        <section class="folders-section section py-5 px-5">
            <div class="columns is-mobile">
                <div class="column">
                    <p class="px-3 is-size-4 has-text-black">
                        <span class="">{{$t('users_management')}}</span>
                    </p>
                    <p class="px-3 is-size-6 has-text-eduloc-grey secondary-font">
                        <span class="">{{$t('users_management_description')}}</span>
                    </p>
                </div>
                <div class="column is-narrow has-text-centered">
                    <div class="level-right" v-if="canCreateUsers">
                    <div class="level-item">
                        <button
                            v-t="'add_user'"
                            class="button is-primary"
                            @click="showInviteModal = true"
                        />
                    </div>
                </div>
                </div>
            </div>
        </section>

        <section class="section pt-5 px-5 pb-6">
            
            <div class="table-container">
                <table
                    class="table is-bordered is-fullwidth is-striped"
                >
                    <thead>
                        <tr class="has-background-primary theader">
                            <th v-t="'User.name'" @click="sort('name')"></th>
                            <th class="fixed-size-2" v-t="'user_entity_permission'"></th>
                            <th class="fixed-size" v-t="'User.state'" @click="sort('state')"></th>
                            <th class="fixed-size" v-t="'ACTIONS_label'"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(member, index) in sortedUsers" :key="index">
                            <td class="is-vcentered">{{ getUserName(member) }} <span v-if="itsMe(member)">({{ $t('me') }})</span></td>
                            <td class="is-vcentered has-text-centered" v-if="isCoordinator(member)">
                                <!--<span
                                    v-t="'Constants.ROLE_COORDINATOR'"
                                    class="lb-role-tag_coordinator ml-2"
                                ></span>-->
                                <label class="secondary-font">
                                    <label class="switch ml-1 disabled">
                                        <input
                                            type="checkbox" disabled
                                        />
                                        <span class="slider round"></span>
                                    </label>
                                </label>
                            </td>
                            <td class="is-vcentered has-text-centered" v-else>
                                <label class="secondary-font">
                                    <label class="switch ml-1">
                                        <input
                                            :ref="'permission-'+index"
                                            type="checkbox"
                                            :checked="member.permission!='GUEST'"
                                            @click="updateUserPermissions(member)"
                                        />
                                        <span class="slider round"></span>
                                    </label>
                                </label>
                                <!--<div class="select pt-1" v-if="member.permission">
                                    <select class="member-permissions" @change="updateUserPermissions(member)" v-model="member.permission">
                                        <option v-for="permission in permissions" :key="permission"
                                            :value="permission" >
                                            {{
                                                $t(
                                                    `user_entity_${permission}`
                                                )
                                            }}
                                        </option>
                                    </select>
                                </div>-->
                            </td>
                            <td class="is-vcentered has-text-centered fixed-size">
                                <span v-if="isCoordinator(member)" v-t="`user_entity_COORDINATOR`"
                                    :class="`lb-role-tag_coordinator`"
                                ></span>
                                <span v-else
                                    v-t="`Constants.STATUS_${member.status}`"
                                    :class="`lb-status-tag_${member.status.toLowerCase()}`"
                                ></span>
                            </td>
                            <td class="is-vcentered has-text-centered fixed-size">
                                <div
                                    v-if="canManageSchool && member._id!==$store.getters.user._id"
                                    class="has-text-centered"
                                    @click.stop.prevent
                                >
                                    <span v-if="!isCoordinator(member)" class="icon is-clickable has-text-primary" @click="removeUser(member._id)" :title="$t('remove_user')">
                                        <i class="far fa-trash-alt"></i>
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
    </div>
</template>

<script>
import { fetchSchoolMembers, removeSchoolMember, updateUserEntityPermissions } from '@/services/API';
import DashboardUsersInviteModal from '@/components/DashboardUsersInviteModal';
import _ from 'underscore';
import Swal from 'sweetalert2';
export default {
    components: {
        DashboardUsersInviteModal,
    },
    data() {
        return {
            users: [],
            showInviteModal: false,
            sortField: 'name',
            reverse: false,
            permissions: ["MEMBER","GUEST"],
        };
    },
    computed: {
        school() {
            return this.$store.getters.school;
        },
        sortedUsers() {
            let sorted = _.sortBy(this.users, this.sortField);
            return this.reverse ? sorted.reverse() : sorted;
        },
        canManageSchool() {
            return this.$store.getters.canManageSchool;
        },
        canCreateUsers() {
            // console.log("can create users?", this.$store.getters.canCreateUser)
            return this.$store.getters.canCreateUser;
        }
    },
    watch: {
        school: {
            handler: 'fetchUsers',
            immediate: true,
        },
    },
    methods: {
        async fetchUsers() {
            this.users = [];
            if (this.$store.getters.school) {
                let response = await fetchSchoolMembers();
                this.users = response.data;
            }
        },
        closeModal() {
            this.showInviteModal = false;
            this.fetchUsers();
        },
        sort(field) {
            if (this.sortField == field) {
                this.reverse = !this.reverse;
            } else {
                this.reverse = false;
            }
            this.sortField = field;
        },
        removeUser(userId) {
            Swal.fire({
                title: this.$t('remove_user_alert_title'),
                text: this.$t('remove_user_alert_text'),
                showCancelButton: true,
                confirmButtonColor: '#cc1e4a',
                cancelButtonColor: '#afafaf',
                confirmButtonText: this.$t('userProfile.leave_school_continue'),
                cancelButtonText: this.$t('userProfile.leave_school_cancel'),
            }).then((result) => {
                if (result.isConfirmed) {
                
                    this.delete(userId);
                }
            });
        },
        async delete(userId) {
            // console.log("removing",userId)
            let error = false;
            await removeSchoolMember(userId)
                .catch((e) => {
                    Swal.fire({
                        title: this.$t('Error.' + e.status),
                        text: this.$t('Error.MY_' + e.data),
                        showCancelButton: false,
                        confirmButtonText: this.$t(
                            'userProfile.leave_school_cancel'
                        ),
                        confirmButtonColor: '#d33',
                    });
                    error = true;
                    return;
                })
                .finally(() => {
                    if (!error) {
                        this.fetchUsers();
                    }
                });
        },
        isCoordinator(member) {
            return member.roles.indexOf("coordinator")!==-1
        },
        async updateUserPermissions(member) {
            if (member.permission == 'GUEST') {
                member.permission = 'MEMBER'
            } else {
                member.permission = 'GUEST'
            }
            let response = await updateUserEntityPermissions(member);
            //console.log(response)
       
        },
        getUserName(member) {
            if (member.name) {
                return member.name;
            }
            return member.owner.name + " " + member.owner.surname;
        },
        itsMe(member) {
            if (member.name) {
                return false;
            }
            return member.owner._id == this.$store.getters.user._id;
        }
    },
};
</script>

<style scoped>
    table td{
        vertical-align: middle;
        font-family: var(--secondary-font);
    }
    .theader th{
        color: #FFFFFF;
        text-align: center;
        font-weight: normal;
        font-size: 1.2rem;
    }
    .title_field{
        max-width: 300px;
    }
    .description_field{
        max-width: 500px;
    }
    .fixed-size{
        width: 150px;
    }
    .select:not(.is-multiple):not(.is-loading)::after{
        margin-top:-1px;
    }
    .fixed-size-2{
        width: 200px;
    }
</style>
